import React from 'react'
import { useDispatch } from 'react-redux'
import { Box, Link, Theme, Typography, useMediaQuery, useTheme } from '@mui/material'
import * as settingsActions from '../../store/settings/settings.actions'
import { useHistory } from 'react-router-dom'

const FooterComponent: React.FC = () => {
  const theme: Theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const history = useHistory()
  const dispatch = useDispatch()

  return (
    <>
      <Box sx={{
        width: '100%',
        display: 'flex',
        backgroundColor: theme.palette.grey.A700,
        padding: '32px',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.secondary.main,
        textTransform: 'uppercase',
      }}
      >
        <Typography variant='caption'>
          {!downSm && '© 2023 | '}
          <Link
            sx={{ cursor: 'pointer' }}
            underline='hover'
            key='imprint'
            color={theme.palette.secondary.main}
            onClick={() => {
              history.replace('/imprint')
              dispatch(settingsActions.setNavPoint(['imprint']))
            }}
          >
            Impressum
          </Link>
          {' | '}
          <Link
            sx={{ cursor: 'pointer' }}
            underline='hover'
            key='security'
            color={theme.palette.secondary.main}
            onClick={() => {
              history.replace('/security')
              dispatch(settingsActions.setNavPoint(['security']))
            }}
          >
            Datenschutzerklärung
          </Link>
        </Typography>

      </Box>
    </>
  )
}

export default FooterComponent
